const ON_CHANGE_DEBOUNCE_TIMER = 150; // Yen Aura: faster quantity updates (stock is 300)

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
